import {
  DC_Domain_Models_Products_DiscountType,
  DC_Domain_Models_Products_OfferType,
  DC_Domain_Models_Products_ProductType,
  Products_Offers_DiscountResponse,
  Products_Offers_PublicOffer,
} from '@monorepo-types/dc';

import { buildOffer, getMPCCodeFromProducts, selectCostDetailsByType, selectOfferByOfferType } from './dc';
import { Product, Offer } from '../types';

export const getNonCommodityProducts = (offer: Products_Offers_DiscountResponse): Product[] => {
  if (offer.products) {
    const productsArray: Product[] = [];
    offer.products?.forEach(product => {
      product.discountProductDetails?.forEach(detail => {
        const selectedProductMonthlyCosts = detail.costDetails?.find(
          cost => cost.type === 'monthlyCostsWithPriceCap',
        )?.costs;

        const selectedProductYearlyCosts = detail.costDetails?.find(cost => cost.type === 'yearlyCosts')?.costs;

        productsArray.push({
          type: product.productType,

          code: detail.code ?? '',
          productCombinationCode: '', // TODO dev -> get productCombinationCode

          variant: offer.offerType,

          mostPopularChoice: detail.code === 'SO210',
          title: detail.description ?? undefined,

          costsMonthly: selectedProductMonthlyCosts,
          costsYearly: selectedProductYearlyCosts,

          costDetails: {
            [`${product.productType}CostDetails`]: detail.productRateDetails?.reduce(
              (acc, item) =>
                Object.assign(acc, {
                  [item.type]: {
                    price: {
                      vat: item.vat,
                      vatExcluded: item.vatExcluded,
                      vatIncluded: item.vatIncluded,
                    },
                    components: item.components,
                  },
                }),
              {},
            ),
            [`${product.productType}Total`]: detail.costDetails?.reduce(
              (acc, item) => Object.assign(acc, { [item.type ?? '']: item.costs }),
              {},
            ),
          },

          contractStartDate: detail.contractStartDate ?? undefined,
          contractEndDate: detail.contractEndDate ?? undefined,
        });
      });
    });
    return productsArray;
  } else {
    return [];
  }
};

export const getNonCommodityOffer = (
  flowContext: { offerType?: DC_Domain_Models_Products_DiscountType },
  productType: DC_Domain_Models_Products_ProductType[],
  offer?: Products_Offers_PublicOffer,
): Offer | undefined => {
  const { offerType } = flowContext;
  if (offer?.offers && offerType) {
    const selectedOffer = selectOfferByOfferType(offer.offers, offerType);
    const selectedProductCombination = getMPCCodeFromProducts(selectedOffer, productType, false, false);
    const selectedProducts = getNonCommodityProducts(selectedOffer);

    return buildOffer({
      offerType,
      usages: offer.usages,
      selectedOffer,
      selectedProducts,
      selectedProductCombination,
      costsMonthly: selectCostDetailsByType('monthlyCostsWithPriceCap', selectedProductCombination?.costDetails),
      costsYearly: selectCostDetailsByType('yearlyCosts', selectedProductCombination?.costDetails),
      costsYearlyPromotion: selectCostDetailsByType('yearlyCostsPromotion', selectedProductCombination?.costDetails),
    });
  }
};

export const getProductTypesFromOfferType = (
  offerType?: DC_Domain_Models_Products_OfferType,
): Array<DC_Domain_Models_Products_ProductType> => {
  switch (offerType) {
    case 'KetelComfort':
      return ['ketelComfort'];
    case 'ServiceGemak':
      return ['servicegemak'];
    case 'RentalDevices':
      return ['huurapparaat'];
    default:
      return [];
  }
};

export const getNonCommodityOffers = (
  flowContext: { offerType?: DC_Domain_Models_Products_DiscountType },
  productType: DC_Domain_Models_Products_ProductType[],
  offer?: Products_Offers_PublicOffer,
): Offer[] =>
  (offer?.offers ?? []).flatMap(
    o => o.offerType && getNonCommodityOffer({ ...flowContext, offerType: o.offerType }, productType, offer),
  ) as Offer[];
